import React, { useState } from 'react';

import { PLAYBOOK_BUILDER_MODE } from '../../../constants/playbookBuilder';
import { pageColumnsCommonStyles } from '../PlaybookBlocksViewIndex/PlaybookBlocksViewIndex';

import { Button } from '../../../design-system';
import { AddLineIcon } from '../../../design-system/Icons';
import BlockOptionsSelector from '../BlockOptionsSelector/BlockOptionsSelector';

const PlaybookPageRightPanel = ({ mode, accessType }) => {
    const [isSelectorOpened, setIsSelectorOpened] = useState(false);

    return (
        <div className={`w-[200px] min-w-[200px] ${pageColumnsCommonStyles}`}>
            {mode === PLAYBOOK_BUILDER_MODE.edit && (
                <div className="relative w-fit">
                    <Button
                        type="primary"
                        size="md"
                        text="Add Block"
                        leadingIcon={AddLineIcon}
                        onClick={() => setIsSelectorOpened(true)}
                    />
                    {isSelectorOpened && (
                        <BlockOptionsSelector
                            position="top-[110%] right-0"
                            isDraggableSelector
                            accessType={accessType}
                            onClose={() => setIsSelectorOpened(false)}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default PlaybookPageRightPanel;
